import {Partner, ProductType} from '@soluto-private/mx-context-types';

export type LinkConfiguration = {
    type: string;
    label?: string;
    url?: string;
};

export type FooterConfiguration = {
    links: LinkConfiguration[];
};

export enum FooterLinkType {
    LegalTerms = 'legal-terms',
    PrivacyPolicy = 'privacy-policy',
    TermsOfUse = 'terms-of-use',
}

export type BannerConfiguration = {
    enabled: boolean;
};

export type AccountNavConfiguration = {
    enabled: boolean;
    links?: LinkConfiguration[];
};

export type I18nConfiguration = {
    defaultLocale: string;
    supportedLocales: string[];
};

export type LeftNavConfiguration = {
    enabled: boolean;
    displayPartnerLogo: boolean;
    links?: LinkConfiguration[];
};

export type MxConfiguration = {
    accountNav: AccountNavConfiguration;
    i18n: I18nConfiguration;
    leftNav: LeftNavConfiguration;
    partnerDisplayName: string;
    productDisplayName?: string;
    unverifiedPlansBanner: BannerConfiguration;
    footer: FooterConfiguration;
};

export type PartnerProductConfigurations = {
    [ProductType.Default]: MxConfiguration;
} & Partial<Record<ProductType, Partial<MxConfiguration>>>;

export type PartnerConfigurations = Record<Partner, PartnerProductConfigurations>;

export const defaultConfiguration: MxConfiguration = {
    accountNav: {enabled: false},
    i18n: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US'],
    },
    leftNav: {enabled: false, displayPartnerLogo: true},
    partnerDisplayName: '',
    productDisplayName: '',
    unverifiedPlansBanner: {
        enabled: true,
    },
    footer: {
        links: [
            {
                type: FooterLinkType.LegalTerms,
                label: 'Legal Terms',
                url: 'https://www.asurion.com/legal/asurion',
            },
            {
                type: FooterLinkType.PrivacyPolicy,
                label: 'Privacy Policy',
                url: 'https://www.asurion.com/privacy-policy/',
            },
            {
                type: FooterLinkType.TermsOfUse,
                label: 'Terms of Use',
                url: 'https://www.asurion.com/website-terms-of-use/',
            },
        ],
    },
};
